import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/mlap'

Styxie.Initializers.MlapSettingsServiceTitan = {
  show: async(props) => {
    const { default: ServiceTitanSettings } = await import('@/vue_widgets/mlap/settings/service_titan/index.vue')
    createVueApp(ServiceTitanSettings, { props, sidebar })
  }
}
